module.exports = __webpack_public_path__ + "img/0xB7624e55ccbB62279b14A7619B585EEd65e6cbde.36ced367.png";